import { render, staticRenderFns } from "./CourseRecDialog.vue?vue&type=template&id=54809489&scoped=true&"
import script from "./CourseRecDialog.vue?vue&type=script&lang=js&"
export * from "./CourseRecDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54809489",
  null
  
)

export default component.exports